<div class="overlay" *ngIf="isLoading | async">
  <div class="spinner">
    <div class="spinner-part spinner-part1"></div>
    <div class="spinner-part spinner-part2"></div>
    <img src="/assets/images/motorbike.png" alt="Suzuki Bike" class="spinner-center">
  </div>
</div>
<div class="main">
  <div class="content">
    <div class="icon-text">
      <div>
        <span style="color: black;font-weight: 500;font-size: 18px;"><img class="bell-icon"
            src="/assets/images/hand.png" style="margin-right: 3px;margin-bottom: 6px;" alt=""> Welcome</span><br>
        <span style="color: black;margin-left: 35px;">Have a nice day at work</span>
      </div>
      <div class="daterange">
        <!-- Toggle Switch -->
        <ng-container >
          <span class="mr-2" style="font-weight: 500;">All Outlets</span>
          <label class="switch mr-1">
            <input type="checkbox" [(ngModel)]="isActiveOutlet" (click)="outletToggle($event.target)">
            <span class="slider-outlet"></span>
          </label>
          <span class="mr-2" style="font-weight: 500;">Hyperlocal Outlets</span>
        </ng-container>
  
        <!-- Date Range Button -->
        <button class="header-btn" (click)="openDateRangePicker()">
          <img style="width: 12px;margin-left: 3px;margin-right: 8px;margin-bottom: 2px;" 
            [src]="bucketurl + '/images/calender.png'" alt="">Date Range
        </button>
      </div>
    </div>
  </div>
  <div class="row date-display justify-content-end mb-3" style="margin-right:-5px">
    <div class="col-auto styled-date-box">
    <span class="date-label-dash" *ngIf="startDate">From:</span> <span class="date-value-dash">{{startDate |
      date:'dd-MMM-yyyy'}}</span>
    <span class="date-label-dash" *ngIf="endDate">To:</span> <span class="date-value-dash">{{endDate |
      date:'dd-MMM-yyyy'}}</span>
      </div>
  </div>
  <div class="filter-wrapper ml-1" *ngIf="[2, 6, 7].includes(roleId)">
    <div class="row justify-content-end">
      <div class="col-auto" *ngIf="roleId == 2">
       <ng-multiselect-dropdown 
          [placeholder]="'Zonal Manager'"
          class="form-control head-multiselect" 
          [settings]="zoneSettings" 
          [data]="zonalList"
          [(ngModel)]="selectedZonalMgrs"
          (onSelect)="onZoneSelect($event)"
          (onDeSelect)="onZoneDeSelect($event)">
        </ng-multiselect-dropdown> 
      </div>
  
      <div class="col-auto" *ngIf="[2, 6].includes(roleId)">
        <ng-multiselect-dropdown 
          [placeholder]="'Regional Manager'"
          class="form-control head-multiselect" 
          [settings]="regionSettings" 
          [data]="regionalList"
          [(ngModel)]="selectedRegionalMgrs"
          (onSelect)="onRegionSelect($event)"
          (onDeSelect)="onRegionDeSelect($event)"
          [disabled]="roleId === 2 && (!selectedZonalMgrs || selectedZonalMgrs.length === 0)"
          (click)="showErrorForRegion()">
        </ng-multiselect-dropdown>
      </div>
  
      <div class="col-auto" *ngIf="[2, 6, 7].includes(roleId)">
        <ng-multiselect-dropdown 
          [placeholder]="'Area Manager'"
          class="form-control head-multiselect" 
          [settings]="areaSettings" 
          [data]="areaList"
          [(ngModel)]="selectedAreaMgrs"
          (onSelect)="onAreaSelect($event)"
          (onDeSelect)="onAreaDeSelect($event)"
          [disabled]="(roleId === 2 || roleId === 6) && (!selectedRegionalMgrs || selectedRegionalMgrs.length === 0)"
          (click)="showErrorForArea()">
        </ng-multiselect-dropdown>
      </div>
  
      <div class="col-auto">
        <button class="btn blue-btn" type="submit" (click)="applyManagers()">Apply</button>
      </div>
      <div class="rotate-icon-container p-0 ml-1 mr-1" (click)="clearFilter(true)">
        <span class="rotate-icon" title="Clear Filter"></span>
      </div>
    </div>
  </div>
  <div class="row mt-1 d-flex justify-content-center" >
    <div class="col-md-3 mb-1 d-flex justify-content-center" *ngFor="let data of followupCards; let i = index; let last = last;">
      <div class="card custom-card text-center" [ngClass]="{'selected-followup-card': selectedFollowupCardIndex === i}"
        (click)="selectFollowupCard(i, data)">
        <div class="info-icon">
          <img class="info" src="/assets/images/info.png" alt="" 
              [adaptivePosition]="false" container="body" placement="left"
              containerClass="tooltipContainer" 
              [tooltip]="data.info">
        </div>
        <div class="card-body d-flex align-items-center justify-content-center">
          <img src="/assets/images/first-followup.png" alt="icon" class="card-icon mr-2">
          <span class="card-text">{{data.title}}</span>
        </div>
      </div>
    </div>
  </div>

  <div class="card-container mr-2"  *ngIf="![5, 6, 7, 8, 9, 10].includes(roleId)">
    <!-- <div class="card card-hover">
      <div class="info-icon"> [style.gridTemplateColumns]="'repeat(' + columns + ', 1fr)'"
        <img class="info" src="/assets/images/info.png" alt="" [adaptivePosition]="false" container="body"
          placement="top" containerClass="tooltipContainer" [tooltip]="enquiry">
      </div>
      <ng-template #enquiry>The total number of
        enquiries created within the selected
        date range, including those from
        Digital Desk and DSEs. It is sum
        total of Hot, Warm, Cold,
        Postponed, Retailed, Booked, Lost
      </ng-template>
      <div class="card-item d-flex align-items-center">
        <span>
          <img class="mr-2 ml-2" src="{{ bucketurl }}/images/leads_dash.png" alt="">
        </span>
        <div class="item-card-val">
          <span>Total Enquiries</span>
          <p> {{totalEnquiries}}</p>
        </div>
      </div>
    </div> -->
    <div class="card card-hover card-select" *ngIf="headerCards.length > 0">
      <div class="info-icon">
        <img class="info" src="/assets/images/info.png" alt="" 
            [adaptivePosition]="false" container="body" placement="top"
            containerClass="tooltipContainer" 
            [tooltip]="getOverallCardInfo()">
      </div>
      <div class="card-item d-flex align-items-center">
        <span>
          <img class="mr-2 ml-2" src="/assets/images/dd-totallead.png" alt="">
        </span>
        <div class="item-card-val">
          <span *ngIf="selectedFollowupCardIndex  === 0 || selectedFollowupCardIndex  === 1" >Overall TAT</span>
          <span *ngIf="selectedFollowupCardIndex  === 2" >Total Avg. Followup Count</span>
             <span *ngIf="selectedFollowupCardIndex  === 3" >Today's Total Follow-up</span>
              <p>{{ selectedFollowupCardIndex  === 3  ? overallCountObj.count : overallCountObj.totalCount  }} 
              </p>
              <ng-template #tolTemplate>Zone wise counts</ng-template>
        </div>
        <div *ngIf="selectedFollowupCardIndex  === 0 || selectedFollowupCardIndex  === 1" class="card-label" style="text-align: right;margin-top: -18px;font-size: 13px;color:#718EBF">{{overallCountObj?.totalLeads ? overallCountObj?.totalLeads : 0}}</div>
      </div>
    </div>
    <div class="card card-hover card-select" [ngClass]="{'selected-card': selectedCardIndex === i}"
      *ngFor="let card of headerCards;let i =index;let last = last;" (click)="selectCard(i, card)">
      <div class="info-icon">
        <img class="info" src="/assets/images/info.png" alt="" 
            [adaptivePosition]="false" container="body" [placement]="last ? 'left' : 'top'"
            containerClass="tooltipContainer" 
            [tooltip]="getTooltipContent(card)">
      </div>
      <div class="card-item d-flex align-items-center">
        <span>
          <img class="mr-2 ml-2" [src]="getIcon(card.name)" alt="">
        </span>
        <div class="item-card-val">
          <span>{{ card.name }}</span>
          <!-- <span [adaptivePosition]="false" container="body" placement="top"
            containerClass="tooltipContainer" [tooltip]="tolTemplate"><img class="info mb-1" lass="mb-1 ml-1"
              src="/assets/images/info.png" alt=""></span> -->

              <p *ngIf="selectedFollowupCardIndex != 2">{{ (selectedFollowupCardIndex  === 0 || selectedFollowupCardIndex  === 1 ) ? card.Count : card.count }}</p>
              <p *ngIf="selectedFollowupCardIndex == 2">{{  card.Count  }} 
                <!-- <span style="font-size: 12px;" *ngIf="card.Count">({{card.count}})</span> -->
              </p>

              <ng-template #tolTemplate>Zone wise counts</ng-template>

         
        </div>
        <div *ngIf="selectedFollowupCardIndex  === 0 || selectedFollowupCardIndex  === 1" class="card-label" style="text-align: right;margin-top: -18px;font-size: 13px;color:#718EBF">{{card?.totalLeads ? card?.totalLeads : 0}}</div>
        <!-- <span
        style="text-align: right;margin-right: 12px;margin-top: -18px;font-size: 13px;color:#718EBF">{{card?.totalLeadsInZone ? card?.totalLeadsInZone : 0}}</span> -->
      </div>
    </div>
  </div>
  <div class="card-container mr-2" *ngIf="![5, 8, 9, 10].includes(roleId)">
    <div class="card card-hover" *ngFor="let card of subHeaderCards">
      <div class="card-item d-flex align-items-center">
        <span>
          <img class="mr-3 ml-2" src="assets/images/tamilnadu.png" alt="">
        </span>
        <div class="item-card-val">
          <span>{{ card.region_name }}</span>
          <p *ngIf="selectedFollowupCardIndex != 2">{{ (selectedFollowupCardIndex  === 0 || selectedFollowupCardIndex  === 1 || selectedFollowupCardIndex  === 2) ? card.Count : card.count }}</p>
          <p *ngIf="selectedFollowupCardIndex == 2">{{  card.Count }} 
             <!-- <span style="font-size: 12px;" *ngIf="card.Count">({{card.count}})</span> -->
            </p>
          <!-- <span
              style="text-align: right;margin-right: 12px;margin-top: -18px;font-size: 13px;color:#718EBF">100%</span> -->
        </div>
        <div *ngIf="selectedFollowupCardIndex  === 0 || selectedFollowupCardIndex  === 1" class="card-label" style="text-align: right;margin-top: -18px;font-size: 13px;color:#718EBF">{{card?.totalLeadsInZone ? card?.totalLeadsInZone : 0}}</div>
      </div>
    </div>
  </div>


</div>



<!-- Filter Section -->
<div class="row mb-2 mt-2 filter-section align-items-center">
  <div style="width:35px" class="p-0"><img class="chart-filter" src="/assets/images/chart_filter.png" alt=""> </div>

   <div class="col" *ngIf="roleId != 5 && roleId != 10 && roleId != 8 && roleId != 9">
    <div class="dropdown">
      <button [ngClass]="{ 'btn-filter-selected': isAnyGeographyChecked }"
        class="btn geo-btn dropdown-toggle d-flex justify-content-between align-items-center" type="button"
        id="geographyDropdown" data-bs-toggle="dropdown" aria-expanded="false">
        <div class="d-flex align-items-center">
          <img [ngClass]="{ 'white-icon': isAnyGeographyChecked }" src="/assets/images/zone.png" alt="">
          <span class="ml-2">Geography</span>
        </div>
        <i class="fas fa-angle-down"></i>
      </button>
      <ul class="dropdown-menu" aria-labelledby="geographyDropdown">
        <div class="mt-1 mr-1 ml-1">
          <input type="text" class="form-control" placeholder="Search..." [(ngModel)]="searchTerm"
            (keyup)="filterDropdownData()" />
        </div>
        <!-- Zones -->
        <li class="dropdown-submenu" *ngFor="let zone of filteredData; let zoneIndex = index">
          <div class="dropdown-submenu mt-1" *ngIf="zoneIndex == 0">
            <div class="dropdown-item d-flex justify-content-between align-items-center">
              <div class="form-check">
                <input type="checkbox" class="form-check-input" id="zone_check_all" [(ngModel)]="selectAllZoneChecked"
                  (change)="onZoneCheckAll($event.target)">
                <img src="/assets/images/zone.png" class=" ml-2" alt="">
                <label class="form-check-label" for="zone_check_all">Select All
                </label>
              </div>
            </div>
            <hr style="margin:1px">
          </div>
          <div class="dropdown-item d-flex justify-content-between align-items-center">
            <div class="form-check">
              <input type="checkbox" class="form-check-input" id="zone{{zone.zone_id}}"
                (change)="onZoneCheck($event.target, zone.zone_id)" [(ngModel)]="zone.checked">
              <img src="/assets/images/zone.png" class="ml-2" alt="">
              <label class="form-check-label" for="zone{{zone.zone_id}}">{{ zone.zone_name }}
                <!-- <div class="form-text">{{ zone.Zone_Manager }}</div> -->
              </label>

            </div>
            <!-- <a class="dropdown-toggle" (click)="toggleDropdown($event)"></a> -->
            <i class="fas fa-angle-right" style="font-size:13px" *ngIf="zone?.States?.length > 0"></i>
          </div>
          <!-- States inside Zone -->
          <ul class="dropdown-menu" *ngIf="zone?.States?.length > 0">
            <li class="dropdown-submenu mt-1">
              <div class="dropdown-item d-flex justify-content-between align-items-center">
                <div class="form-check">
                  <input type="checkbox" class="form-check-input" id="region_check_all"
                    [(ngModel)]="zone.selectALlStateChecked"
                    (change)="onStateCheckAll($event.target, zone.zone_id, zone)">
                  <img src="/assets/images/zone.png" class=" ml-2" alt="">
                  <label class="form-check-label" for="region_check_all">Select All</label>
                </div>
              </div>
            </li>
            <hr style="margin:1px">
            <li class="dropdown-submenu" *ngFor="let state of zone.States">
              <div class="dropdown-item d-flex justify-content-between align-items-center">
                <div class="form-check">
                  <input type="checkbox" class="form-check-input" id="state{{state.state_id}}"
                    (change)="onStateCheck($event.target, zone.zone_id, state.state_id)" [(ngModel)]="state.checked">
                  <img src="/assets/images/zone.png" class="ml-2" alt="">
                  <label class="form-check-label" for="state{{state.state_id}}">
                    {{ state.state_name }}
                  </label>
                </div>
                <i class="fas fa-angle-right" style="font-size:13px" *ngIf="state?.Regions?.length > 0"></i>
              </div>

              <!-- Regions inside State -->
              <ul class="dropdown-menu" *ngIf="state?.Regions?.length > 0">
                <li class="dropdown-submenu mt-1">
                  <div class="dropdown-item d-flex justify-content-between align-items-center">
                    <div class="form-check">
                      <input type="checkbox" class="form-check-input" id="region_check_all"
                        [(ngModel)]="state.selectAllChecked"
                        (change)="onRegionCheckAll($event.target, zone.zone_id, state.state_id, state)">
                      <img src="/assets/images/zone.png" class=" ml-2" alt="">
                      <label class="form-check-label" for="region_check_all">Select All</label>
                    </div>
                  </div>
                </li>
                <hr style="margin:1px">
                <li class="dropdown-submenu" *ngFor="let region of state.Regions">
                  <div class="dropdown-item d-flex justify-content-between align-items-center">
                    <div class="form-check">
                      <input type="checkbox" class="form-check-input" id="region{{region.region_id}}"
                        (change)="onRegionCheck($event.target, zone.zone_id,  state.state_id,region.region_id)"
                        [(ngModel)]="region.checked">
                      <img src="/assets/images/zone.png" class=" ml-2" alt="">
                      <label class="form-check-label" for="region{{region.region_id}}">
                        {{ region.region_name }}
                      </label>
                    </div>
                    <i class="fas fa-angle-right" style="font-size:13px" *ngIf="region?.ParentDealers?.length > 0"></i>
                  </div>

                  <!-- Areas inside Region -->
                  <ul class="dropdown-menu" *ngIf="region?.ParentDealers?.length > 0">
                    <div class="sub-list">
                      <li class="dropdown-submenu mt-1">
                        <div class="dropdown-item d-flex justify-content-between align-items-center">
                          <div class="form-check">
                            <input type="checkbox" class="form-check-input" id="area_check_all"
                              [checked]="region.selectAllAreasChecked"
                              (change)="onAreaCheckAll($event.target, zone.zone_id, state.state_id, region.region_id)">
                            <img src="/assets/images/zone.png" class=" ml-2" alt="">
                            <label class="form-check-label" for="area_check_all">Select All</label>
                          </div>
                        </div>
                      </li>
                      <hr style="margin:1px">
                      <li class="dropdown-submenu" *ngFor="let parent of region.ParentDealers">
                          <ng-container *ngFor="let outlet of parent.Outlets">
                            <div class="dropdown-item">
                              <div class="form-check">
                                <input type="checkbox" class="form-check-input two-labels"
                                  id="outlet{{outlet.outlet_id}}" [(ngModel)]="outlet.checked"
                                  (change)="onAreaCheck($event.target, zone.zone_id, state.state_id, region.region_id, outlet.outlet_id)">
                                <img src="/assets/images/zone.png"  class="ml-2" alt="">
                                <label class="form-check-label" for="outlet{{outlet.outlet_id}}">
                                  {{ outlet.outlet_name }} ({{ outlet.outlet_code }})
                                </label>
                              </div>
                            </div>
                        </ng-container>
                      </li>
                    </div>
                  </ul>
                </li>
              </ul>
            </li>
          </ul>

        </li>
        <li class="dropdown-submenu" *ngIf="filteredData.length == 0">
          <div class="dropdown-item d-flex justify-content-between align-items-center mb-2">
            <span style="font-size: 13px;">Not found!</span>
          </div>
        </li>
      </ul>
    </div>
  </div>
  <!-- <div class="col p-0 ml-1" *ngIf="roleId == 8 || roleId == 9">
    <div class="dropdown">
      <button class="btn geo-btn dropdown-toggle d-flex justify-content-between align-items-center" type="button"
        id="geographyDropdown" data-bs-toggle="dropdown" aria-expanded="false">
        <div class="d-flex align-items-center">
          <img src="/assets/images/outlet-dropdown.png" alt="">
          <span class="ml-2">Dealer</span>
        </div>
        <i class="fas fa-angle-down"></i>
      </button>
      <ul class="dropdown-menu" aria-labelledby="geographyDropdown">
        <div class="mt-1 mr-1 ml-1">
          <input type="text" class="form-control" placeholder="Search..." [(ngModel)]="searchTermDealer"
            (keyup)="filterDealerData()" />
        </div>
      
        <li class="dropdown-submenu" *ngFor="let dealer of filteredDealerData.slice(0,10); let dealerIndex = index">
          <div class="dropdown-item d-flex justify-content-between align-items-center">
            <div class="form-check">
              <input type="checkbox" class="form-check-input" id="dealer{{dealer.parent_dealer_id}}"  [disabled] = "!isAnyAreaChecked && ![8, 9].includes(roleId)"
                (change)="onDealerCheck($event.target, dealer.parent_dealer_id)" [(ngModel)]="dealer.checked">
              <img src="/assets/images/outlet-dropdown.png" class="ml-2" alt="">
              <label class="form-check-label" for="dealer{{dealer.parent_dealer_id}}">{{ dealer.parent_dealer_name }}
                ({{ dealer.dealer_code}})
              </label>
            </div>
            <i class="fas fa-angle-right" style="font-size:13px" *ngIf="dealer?.Outlets?.length > 0"></i>
          </div>
          <ul class="dropdown-menu" *ngIf="dealer?.Outlets?.length > 0">
            <li class="dropdown-submenu" *ngFor="let outlet of dealer.Outlets; let outletIndex = index">
              <div class="dropdown-item d-flex justify-content-between align-items-center">
                <div class="form-check">
                  <input type="checkbox" class="form-check-input" id="outlet{{outlet.outlet_id}}"  [disabled] = "!isAnyAreaChecked && ![8, 9].includes(roleId)"
                    (change)="onOutletCheck($event.target, dealer.parent_dealer_id, outlet.outlet_id)"
                    [(ngModel)]="outlet.checked">
                  <img src="/assets/images/outlet-dropdown.png"  class=" ml-2" alt="">
                  <label class="form-check-label" for="outlet{{outlet.outlet_id}}">{{ outlet.outlet_name }} ({{
                    outlet.outlet_code}}) 
                  </label>
                </div>
              </div>
            </li>
          </ul>
        </li>
        <li class="dropdown-submenu" *ngIf="filteredDealerData.length == 0">
          <div class="dropdown-item d-flex justify-content-between align-items-center mb-2">
            <span style="font-size: 13px;">Not found!</span>
          </div>
        </li>
      </ul>
    </div>
  </div> -->
  <div class="col p-0 ml-1" *ngIf="roleId == 8 || roleId == 9 || roleId == 5 ||  roleId == 10 ">
    <div class="dropdown">
      <button [ngClass]="{ 'btn-filter-selected': isAnyOutletChecked }" class="btn geo-btn dropdown-toggle d-flex justify-content-between align-items-center" type="button"
        id="geographyDropdown" data-bs-toggle="dropdown" aria-expanded="false">
        <div class="d-flex align-items-center">
          <img [ngClass]="{ 'white-icon': isAnyOutletChecked }" src="/assets/images/outlet-dropdown.png" alt="">
          <span class="ml-2">Outlet</span> <!-- Changed from Dealer to Outlet -->
        </div>
        <i class="fas fa-angle-down"></i>
      </button>
      <ul class="dropdown-menu" aria-labelledby="geographyDropdown">
        <div class="mt-1 mr-1 ml-1">
          <input type="text" class="form-control" placeholder="Search..." [(ngModel)]="searchTermDealer"
            (keyup)="filterDealerData()" />
        </div>
  
        <!-- Loop through only outlets -->
         <div class="sub-list">
        <li class="dropdown-item" *ngFor="let outlet of filteredDealerData">
          <div class="d-flex justify-content-between align-items-center">
            <div class="form-check">
              <input type="checkbox" class="form-check-input" id="outlet{{outlet.outlet_id}}"
                [disabled]="!isAnyAreaChecked && ![8, 9, 5, 10].includes(roleId)"
                (change)="onOutletCheck($event.target, outlet.parent_dealer_id, outlet.outlet_id)"
                [(ngModel)]="outlet.checked">
              <img src="/assets/images/outlet-dropdown.png" class=" ml-2" alt="">
              <label class="form-check-label" for="outlet{{outlet.outlet_id}}">
                {{ outlet.outlet_name }} ({{ outlet.outlet_code }})
              </label>
            </div>
          </div>
        </li>
      </div>
        <li class="dropdown-item text-center text-muted" *ngIf="filteredDealerData.length == 0">
          <span>Not found!</span>
        </li>
      </ul>
    </div>
  </div>
  <div class="col p-0 ml-1">
    <div class="dropdown">
      <button [ngClass]="{ 'btn-filter-selected': isAnySourceChecked }" class="btn geo-btn dropdown-toggle d-flex justify-content-between align-items-center" type="button"
        id="geographyDropdown" data-bs-toggle="dropdown" aria-expanded="false">
        <div class="d-flex align-items-center">
          <img [ngClass]="{ 'white-icon': isAnySourceChecked }" src="/assets/images/source.png" alt="">
          <span class="ml-2">Source</span>
        </div><i class="fas fa-angle-down"></i>
      </button>


      <ul class="dropdown-menu">
        <li class="dropdown-submenu mt-1" *ngFor="let leadsource of filteredDataSource; let sourceIndex = index">
          <div class="dropdown-item d-flex justify-content-between align-items-center" *ngIf="sourceIndex == 0">
            <div class="form-check">
              <input type="checkbox" class="form-check-input" id="source_check_all" [(ngModel)]="selectAllSourceChecked"
                (change)="onSourceCheckAll($event.target)">
              <img src="/assets/images/source.png" class=" ml-2" alt="">
              <label class="form-check-label" for="source_check_all">Select All
              </label>
            </div>
          </div>
        </li>
        <hr style="margin:1px">
        <li class="dropdown-submenu" *ngFor="let leadsource of filteredDataSource; let sourceIndex = index">
          <div class="dropdown-item d-flex justify-content-between align-items-center">
            <div class="form-check">
              <input type="checkbox" class="form-check-input" id="ls_{{leadsource.id}}"
                (change)="onSourceCheck($event.target, leadsource.base_lead_source_id, leadsource.id)"
                [(ngModel)]="leadsource.checked">
              <img src="/assets/images/source.png" class="ml-2" alt="">
              <label class="form-check-label" for="ls_{{leadsource.id}}">{{ leadsource.lead_source }}</label>
            </div>
            <i class="fas fa-angle-right" style="font-size:13px" *ngIf="leadsource?.lead_sub_sources?.length > 0"></i>
          </div>
          <ul class="dropdown-menu" *ngIf="leadsource?.lead_sub_sources?.length > 0">
            <li class="dropdown-submenu mt-1">
              <div class="dropdown-item d-flex justify-content-between align-items-center">
                <div class="form-check">
                  <input type="checkbox" class="form-check-input" id="sub_source_check_all"
                    [(ngModel)]="leadsource.selectAllSubSourceChecked"
                    (change)="onSubSourceCheckAll($event.target, leadsource.base_lead_source_id, leadsource.id)">
                  <img src="/assets/images/source.png" class=" ml-2" alt="">
                  <label class="form-check-label" for="sub_source_check_all">Select All
                  </label>
                </div>
              </div>
            </li>
            <hr style="margin:1px">
            <div class="sub-list">
              <li class="dropdown-submenu"
                *ngFor="let subsource of leadsource.lead_sub_sources; let subSourceIndex = index">
                <div class="dropdown-item d-flex justify-content-between align-items-center">
                  <div class="form-check">
                    <input type="checkbox" class="form-check-input" id="ss_{{subsource.id}}"
                      (change)="onSubsourceCheck($event.target, leadsource.base_lead_source_id, leadsource.id , subsource.id)"
                      [(ngModel)]="subsource.checked">
                    <img src="/assets/images/source.png" class="ml-2" alt="">
                    <label class="form-check-label" for="ss_{{subsource.id}}">{{ subsource.lead_sub_source
                      }}</label>
                  </div>
                </div>
              </li>
            </div>
          </ul>
        </li>
        <li class="dropdown-submenu" *ngIf="filteredDataSource.length == 0">
          <div class="dropdown-item d-flex justify-content-between align-items-center mb-2">
            <span style="font-size: 13px;">No data found!</span>
          </div>
        </li>
      </ul>
    </div>
  </div>
  <div class="col p-0 ml-1" *ngIf="isUserType">
    <div class="dropdown">
      <button class="btn geo-btn dropdown-toggle d-flex justify-content-between align-items-center" type="button"
        id="geographyDropdown" data-bs-toggle="dropdown" aria-expanded="false">
        <div class="d-flex align-items-center">
          <img src="/assets/images/user-dropdown.png" alt="">
          <span class="ml-2">User Type</span>
        </div><i class="fas fa-angle-down"></i>
      </button>

      <ul class="dropdown-menu" aria-labelledby="geographyDropdown">
        <div class="sub-list">
          <li class="dropdown-submenu" *ngFor="let data of userData;let i=index">
            <div class="dropdown-item d-flex justify-content-between align-items-center">
              <div class="form-check">
                <input type="checkbox" class="form-check-input" id="status_{{data.role_id}}" [(ngModel)]="data.checked"
                  (change)="onUserCheck($event.target, data)">
                <img src="/assets/images/user-dropdown.png" class="ml-2" alt="">
                <label class="form-check-label" for="status_{{data.role_id}}">{{ data.role_name }}</label>
              </div>
            </div>
          </li>
          <li class="dropdown-submenu" *ngIf="userData.length == 0">
            <div class="dropdown-item d-flex justify-content-between align-items-center mb-2">
              <span style="font-size: 13px;">No data found!</span>
            </div>
          </li>
        </div>
      </ul>
    </div>
  </div>
  <div class="col p-0 ml-1">
    <div class="dropdown">
      <button  [ngClass]="{ 'btn-filter-selected': isAnyCategoryChecked }" class="btn geo-btn dropdown-toggle d-flex justify-content-between align-items-center" type="button"
        id="geographyDropdown" data-bs-toggle="dropdown" aria-expanded="false">
        <div class="d-flex align-items-center">
          <img  [ngClass]="{ 'white-icon': isAnyCategoryChecked }"  src="/assets/images/product.png" alt="">
          <span class="ml-2 mr-2">Product Category</span>
        </div><i class="fas fa-angle-down"></i>
      </button>

      <ul class="dropdown-menu" aria-labelledby="geographyDropdown">
        <li class="dropdown-submenu mt-1">
          <div class="dropdown-item d-flex justify-content-between align-items-center">
            <div class="form-check">
              <input type="checkbox" class="form-check-input" id="category_check_all"
                [(ngModel)]="selectAllCategoryChecked" (change)="onCategoryCheckAll($event.target)">
              <img src="/assets/images/product.png" class=" ml-2" alt="">
              <label class="form-check-label" for="category_check_all">Select All
              </label>
            </div>
          </div>
        </li>
        <hr style="margin:1px">
        <li class="dropdown-submenu" *ngFor="let data of categoryData; let i = index">
          <div class="dropdown-item d-flex justify-content-between align-items-center">
            <div class="form-check">
              <input type="checkbox" class="form-check-input" id="cat_{{data.category_id}}" [(ngModel)]="data.checked"
                (change)="onCategoryCheck($event.target, data.category_id)">
              <img src="/assets/images/product.png" class="ml-2" alt="">
              <label class="form-check-label" for="cat_{{data.category_id}}">{{ data.category_name }}</label>
            </div>
          </div>
        </li>
        <li class="dropdown-submenu" *ngIf="categoryData.length == 0">
          <div class="dropdown-item d-flex justify-content-between align-items-center mb-2">
            <span style="font-size: 13px;">No data found!</span>
          </div>
        </li>
      </ul>
    </div>
  </div>

  <div class="col p-0 ml-1">
    <div class="dropdown">
      <button [ngClass]="{ 'btn-filter-selected': isAnyModelChecked }" class="btn geo-btn dropdown-toggle d-flex justify-content-between align-items-center" type="button"
        id="geographyDropdown" data-bs-toggle="dropdown" aria-expanded="false">
        <div class="d-flex align-items-center">
          <img [ngClass]="{ 'btn-filter-selected': isAnyModelChecked }" src="/assets/images/product.png" alt="">
          <span class="ml-2">Product Model</span>
        </div><i class="fas fa-angle-down"></i>
      </button>

      <ul class="dropdown-menu" aria-labelledby="geographyDropdown">
        <li class="dropdown-submenu mt-1">
          <div class="dropdown-item d-flex justify-content-between align-items-center">
            <div class="form-check">
              <input type="checkbox" class="form-check-input" id="model_check_all"
                [(ngModel)]="selectAllModelChecked" (change)="onModelCheckAll($event.target)">
              <img src="/assets/images/product.png" class=" ml-2" alt="">
              <label class="form-check-label" for="model_check_all">Select All
              </label>
            </div>
          </div>
        </li>
        <hr style="margin:1px">
        <div class="sub-list">
          <li class="dropdown-submenu" *ngFor="let data of filteredModelData;let i = index;">
            <div class="dropdown-item d-flex justify-content-between align-items-center">
              <div class="form-check">
                <input type="checkbox" class="form-check-input" id="model_{{data.model_id}}" [(ngModel)]="data.checked"
                  (change)="onModelCheck($event.target)">
                <img src="/assets/images/product.png" class="ml-2" alt="">
                <label class="form-check-label" for="model_{{data.model_id}}">{{ data.model_name }}</label>
              </div>
            </div>
          </li>
          <li class="dropdown-submenu" *ngIf="filteredModelData.length == 0">
            <div class="dropdown-item d-flex justify-content-between align-items-center mb-2">
              <span style="font-size: 13px;">No data found!</span>
            </div>
          </li>
        </div>
      </ul>
    </div>
  </div>

  <div class="col-1 p-0 ml-1" style="width: auto;">
    <button class="btn blue-btn" type="submit" (click)="applyFilter()">Apply</button>
  </div>
  <div class="rotate-icon-container p-0 ml-1" (click)="clearFilter(false)">
    <span class="rotate-icon" title="Clear Filter"></span>
  </div>
</div>


<!-- Carousel Section for Charts -->
<div class="pie-background mt-2 mb-3 mr-1 ml-1 row" >
  <div class="col" >
    <div class="ml-2 mt-1">
      <h1 class="chart-head" *ngIf="roleId != 8 && roleId != 9  && roleId != 5 && roleId != 10">Geography Performance <span style="font-size:14px" *ngIf="selectedFollowupCardIndex == 1">(Assigned by Digital Desk)</span></h1>
        <h1 class="chart-head" *ngIf="roleId == 8 || roleId == 9">Dealer Performance</h1>
         <h1 class="chart-head" *ngIf="roleId == 5 ||  roleId == 10 ">Outlet Performance</h1>
    </div>
    <div  #chartCarousel id="chartCarousel" class="carousel slide"  data-ride="carousel">
      <div class="carousel-inner" >
        <ng-container *ngIf="chartsData.length != 0 && formattedTotalCount != 0">
          <ng-container *ngFor="let chart of chartsData; let i = index">
            <ng-container *ngIf="i % 2 === 0">
              <div class="carousel-item" [class.active]="i === 0 && i % 2 === 0">
                <!-- Only first even item has 'active' -->
                <div class="row" *ngIf="i % 2 === 0">
                  <!-- Display charts in pairs  *ngIf="chartsData[i + 1]; else singleChart"-->
                  <div class="col-6 chart-body" *ngIf="chartsData[i + 1]; else singleChart;">
                    <p-chart style="width: 240px !important;height: 240px !important;" width="240" height="240"
                      type="doughnut" class="pie-chart" [data]="chart.data" [options]="chart.options"></p-chart>
                    <div class="chart-label mt-2">{{ chart.options.title }}
                      <div class="chart-sub-label" *ngIf="chart.options.subText1">
                        {{ chart.options.subText1 }}
                      </div>
                    </div>
                  </div>

                  <div class="col-6 chart-body" *ngIf="chartsData[i + 1]">
                    <p-chart style="width: 240px !important;height: 240px !important;" width="240" height="240"
                      type="doughnut" class="pie-chart" [data]="chartsData[i + 1].data"
                      [options]="chartsData[i + 1].options"></p-chart>
                    <div class="chart-label mt-2">
                      {{ chartsData[i + 1].options.title }}
                      <div class="chart-sub-label" *ngIf="chartsData[i + 1].options.subText1">
                        {{ chartsData[i + 1].options.subText1 }}
                      </div>
                    </div>
                  </div>
                  <ng-template #singleChart>
                    <div class="col-12 chart-body">
                      <p-chart style="width: 240px !important; height: 240px !important;" width="240" height="240"
                        type="doughnut" class="pie-chart" [data]="chart.data" [options]="chart.options"></p-chart>
                        <div class="chart-label mt-1" *ngIf="chart.options.title">{{ chart.options.title }}
                          <div class="chart-sub-label" *ngIf="chart.options.subText1">
                            {{ chart.options.subText1 }}
                          </div>
                        </div>
                    </div>
                  </ng-template>
                </div>
              </div>
            </ng-container>
          </ng-container>
        </ng-container>
        <ng-container *ngIf="chartsData.length == 0 || formattedTotalCount == 0">
          <div class="no-data-available">
            <img style="width:370px" [src]="bucketurl + '/images/no-data-available.png'" alt="">
          </div>
        </ng-container>
   
      </div>
      <!-- <div class="row justify-content-center mt-4">
        <div *ngFor="let status of statusesToggle; let i = index"
        class="col-3 justify-content-center legend-item d-flex align-items-center">
        <div class="slide-toggle-container ml-2">
          <span class="slider-label">{{ status.label }}</span>
        </div>
        <label class="slide-toggle ml-2 mr-3">
          <input type="checkbox" [(ngModel)]="status.checked" (change)="toggleStatus(status, $event.target)">
          <span class="slider round"></span>
        </label>
      </div>
    </div> -->
      <ng-container *ngIf="chartsData.length > 2">
        <!-- Carousel Controls -->
        <a class="carousel-control-prev" style="margin-left: -25px !important;" (click)="prevSlide()" role="button" [class.disabled]="currentIndex === 0"
          data-slide="prev">
          <!-- <span class="carousel-control-prev-icon" aria-hidden="true"></span>
      <span class="sr-only">Previous</span> -->
          <img src="/assets/images/prev-btn.png" alt="">
        </a>
        <a class="carousel-control-next" style="margin-right: -25px !important;" (click)="nextSlide()" role="button" [class.disabled]="currentIndex === totalSlides - 1"
          data-slide="next">
          <!-- <span class="carousel-control-next-icon" aria-hidden="true"></span>
      <span class="sr-only">Next</span> -->
          <img src="/assets/images/next-btn.png" alt="">
        </a>
      </ng-container>
    </div>
  </div>
  <!-- <div class="col-4 leads-status-box">
    <div class="status-legend">
      <div *ngFor="let status of statusesToggle; let i = index"
        class="legend-item d-flex justify-content-between align-items-center">
        <div class="slide-toggle-container ml-2">
          <span class="slider-label">{{ status.label }}</span>
        </div>
        <label class="slide-toggle mr-4">
          <input type="checkbox" [(ngModel)]="status.checked" (change)="toggleStatus(status, $event.target)">
          <span class="slider round"></span>
        </label>
      </div>
    </div>
  </div> -->

</div>

<div class="graph row mb-3 mr-1 ml-1"  *ngIf="selectedFollowupCardIndex != 1">
  <div class="col-12">
    <div class="d-flex justify-content-between align-items-center header-container">
      <h1 class="chart-head">Follow Up Count</h1>
      <div class="comparison d-flex align-items-center">
  
        <div *ngIf="visibleBarMonth" class="datepick d-flex align-items-center ml-4">
          <div>
            <input type="text" class="form-control" [bsConfig]="bsConfig" #dpBarStart="bsDatepicker" bsDatepicker
              readonly (keydown)="preventTyping($event)" [(bsValue)]="horizontalBarStartMonth" placeholder="Select Month">
          </div>
          <span class="mx-2">To</span>
          <div>
            <input type="text" class="form-control" [bsConfig]="bsConfig" #dpBarEnd="bsDatepicker" bsDatepicker
              readonly (keydown)="preventTyping($event)" [(bsValue)]="horizontalBarEndMonth" placeholder="Select Month">
          </div>
          <div class="ml-3">
            <button class="btn compare" type="button">
              <i class="fa fa-exchange-alt" title="Compare" (click)="compareBarChart()"></i>
            </button>
            <button class="btn btn-secondaryd clear" (click)="clearBarChart()">
              <i class="fa fa-times-circle" title="Clear Comparison"></i>
            </button>
          </div>
        </div>
        <div class="stats mr-3" *ngIf="selectedFollowupCardIndex != 0">
          <span class="stat-title mr-1" >Zero follow up</span>
          <span class="stat-value">{{currentuntouch}}</span>
        </div>
        <div class="stats mr-3" *ngIf="selectedFollowupCardIndex != 0">
          <span class="stat-title mr-1">Total Enquiries</span>
          <span class="stat-value">{{currenttotaltouch}}</span>
        </div>
      
      </div>
    </div>
    <div class="d-flex align-items-center header-container stats-row" *ngIf="selectedFollowupCardIndex == 0">
      <div class="stats" *ngIf="selectedFollowupCardIndex == 0">
        <span class="stat-title mr-1" >Total Leads</span>
        <span class="stat-value">{{stageCounts?.totalLeads || 0}}</span>
      </div>
      <div class="stats" *ngIf="selectedFollowupCardIndex == 0">
        <span class="stat-title mr-1">Untouched</span>
        <span class="stat-value">{{stageCounts?.untouchedLeads || 0}}</span>
      </div>
      <div class="stats" style="background-color: #1890FF;" *ngIf="selectedFollowupCardIndex == 0">
        <span class="stat-title mr-1" style="color: white;">Follow-up & No-response</span>
        <span class="stat-value">{{(stageCounts?.followUp + stageCounts?.noResponse) || 0 }}</span>
      </div>
      <div class="stats" *ngIf="selectedFollowupCardIndex == 0">
        <span class="stat-title mr-1">Disposed (Junk/Drop)</span>
        <span class="stat-value">{{stageCounts?.junk || 0}}</span>
      </div>
      <div class="stats" *ngIf="selectedFollowupCardIndex == 0">
        <span class="stat-title mr-1">Disposed (Non-Sales)</span>
        <span class="stat-value">{{stageCounts?.nonSales || 0}}</span>
      </div>
      <div class="stats" *ngIf="selectedFollowupCardIndex == 0">
        <span class="stat-title mr-1">Disposed (Assigned to DSE)</span>
        <span class="stat-value">{{stageCounts?.assigned || 0}}</span>
      </div>
     
    </div>
    
    <div class="row">
      <ng-container *ngIf="horizontalBarOptions.series.length > 0">
        <apx-chart #horizontalChart
        [series]="horizontalBarOptions.series"
        [chart]="horizontalBarOptions.chart"
        [dataLabels]="horizontalBarOptions.dataLabels"
        [plotOptions]="horizontalBarOptions.plotOptions"
        [xaxis]="horizontalBarOptions.xaxis"
        [stroke]="horizontalBarOptions.stroke"
      ></apx-chart>
    </ng-container>
      <ng-container *ngIf="horizontalBarOptions.series.length == 0">
        <div class="no-data-available">
          <img [src]="bucketurl + '/images/no-data-available.png'" alt="">
        </div>
      </ng-container>
    </div>
  </div>
</div> 



<!-- <div class="pie-background  mr-1 ml-1 mb-4 row">
  <div class="d-flex justify-content-between align-items-center">
  <h3 class="chart-head">Follow Up Count</h3>
  
  <div class="d-flex">
    <div class="stats mr-3">
      <span class="stat-title mr-1">Total Enquiries</span>
      <span class="stat-value">{{totalEnquiriesTable}}</span>
    </div>
    <div class="stats mr-3">
      <span class="stat-title mr-1">Zero follow up</span>
      <span class="stat-value">{{untouchedEnquiriesTable}}</span>
    </div>
  </div>
</div>

  <div class="table-responsive performance-table">
    <table class="table" *ngIf="roleId != 8 && roleId != 9 && roleId != 5 && roleId != 10">
      <thead class="performance-head sticky-header">
        <tr>
          <th> <img src="/assets/images/perform-geo.png" class="mr-1" alt=""> Number of Follow Ups</th>
          <th> <img src="/assets/images/tat.png" class="mr-1" alt="">TaT</th>
          <th> <img src="/assets/images/perform-enquiries.png" class="mr-1" alt="">Count of Enquiries</th>
          <th> <img src="/assets/images/perform-test-ride.png" class="mr-1" alt="">Test Ride</th>
          <th> <img src="/assets/images/list.png" class="mr-1" alt="">Booked</th>
          <th> <img src="/assets/images/perform-retailed.png" class="mr-1" alt="">Retailed</th>
          <th> <img src="/assets/images/table-lost.png" class="mr-1" alt="">Lost</th>
        </tr>
      </thead>
      <tbody>
        <ng-container *ngFor="let zone of follwupCountData">
          <tr>
            <td style="text-align: center;">{{ zone["_id"] }}</td>
            <td style="text-align: center;">{{ zone.assigncount }}</td>
            <td style="text-align: center;">{{ zone.count }} <span *ngIf="zone.count">({{zone.enquiriesPer}}%) </span></td>
            <td style="text-align: center;">{{ zone.testride }} <span *ngIf="zone.testride">({{zone.testRidePer}}%)</span></td>
            <td style="text-align: center;">{{ zone.booked }} <span *ngIf="zone.booked">({{zone.booked}}%)</span></td>
            <td style="text-align: center;">{{ zone.retail }}<span *ngIf="zone.retail"> ({{zone.retailPer}}%)</span></td>
            <td style="text-align: center;">{{ zone.lost }} <span *ngIf="zone.lost">({{zone.lostPer}}%)</span></td>
          </tr>
        </ng-container>
        
        <ng-container *ngIf="follwupCountData.length == 0">
          <tr>
            <td colspan="7" style="text-align: center;">No data available!</td>
          </tr>
        </ng-container>
      </tbody>
    </table>
  </div>
</div>  -->



<!-- <div class="graph row mb-4 mr-1 ml-1">
  <div class="col-12">
    <div class="d-flex justify-content-between align-items-center">
      <h1 class="chart-head">Assigned Vs Follow-Up</h1>
      <div class="comparison d-flex align-items-cente">
        <span *ngIf="!visibleFollowupMonth" class="comparebtn" (click)="onclick()">Compare
          <img class="ml-2 logo-white" [src]="bucketurl + '/icons/calendar.png'" alt="">
        </span>
        <div *ngIf="visibleFollowupMonth" class="datepick d-flex align-items-cente">
          <div>
            <input type="text" class="form-control" [bsConfig]="bsConfig" #dpFollowupStart="bsDatepicker" bsDatepicker
              readonly (keydown)="preventTyping($event)" [(bsValue)]="followupStartMonth" placeholder="Select Month">
          </div>
          <span class="m-2">To</span>
          <div>
            <input type="text" class="form-control" [bsConfig]="bsConfig" #dpFollowupEnd="bsDatepicker" bsDatepicker
              readonly (keydown)="preventTyping($event)" [(bsValue)]="followupEndMonth" placeholder="Select Month">
          </div>
          <div>
            <button class="btn compare" type="button">
              <i class="fa fa-exchange-alt" title="Compare" (click)="compareLineChart()"></i>
            </button>
            <button class="btn btn-secondaryd clear" (click)="clearFollow()">
              <i class="fa fa-times-circle" title="Clear Comparison"></i>
            </button>
          </div>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="chart-scroll-container">
        <apx-chart #lineChart [series]="followupOptions.series" [chart]="followupOptions.chart"
          [xaxis]="followupOptions.xaxis" [yaxis]="followupOptions.yaxis" [dataLabels]="followupOptions.dataLabels"
          [stroke]="followupOptions.stroke" [grid]="followupOptions.grid" [legend]="followupOptions.legend">
        </apx-chart>
      </div>
    </div>
  </div>
</div> -->



<ng-template #dateRangePicker>
  <h4 mat-dialog-title>
    Date Range
    <img class="close-button"  mat-dialog-close src="/assets/images/close.png"  alt="" (click)="reset()">
  </h4>
  <mat-dialog-content class="date-range-picker">
    <div class="date-range-picker__content">
      <div class="date-range-picker__sidebar">
        <button class="date-btn" mat-button class="sidebar-button" [class.selected]="selectedButton === 'today'"
          (click)="selectToday()">Today</button>
        <button mat-button class="sidebar-button" [class.selected]="selectedButton === 'last7'"
          (click)="selectLast7Days()">Last 7 days</button>
        <button mat-button class="sidebar-button" [class.selected]="selectedButton === 'last15'"
          (click)="selectLast15Days()">Last 15 days</button>
        <button mat-button class="sidebar-button" [class.selected]="selectedButton === 'thisMonth'"
          (click)="selectThisMonth()"><span *ngIf="isDateOne">Last Month</span><span *ngIf="!isDateOne">This Month</span></button>
        <button mat-button class="sidebar-button" [class.selected]="selectedButton === 'custom'"
          (click)="selectCustom()">Custom</button>
      </div>
      <div class="date-range-picker__main" [ngClass]="{ 'isDateCustom': selectedButton != 'custom'}">
        <mat-calendar (selectedChange)="selectedChange($event)" [maxDate]="today" [selected]="dateRange"
          #startCalendar></mat-calendar>
      </div>
    </div>

    <div mat-dialog-actions class="d-flex justify-content-between align-items-center">
      <div class="date-display">
        <span class="date-label" *ngIf="startDate">From:</span> <span class="date-value">{{startDate |
          date:'dd-MMM-yyyy'}}</span>
        <span class="date-label ml-2" *ngIf="endDate">To:</span> <span class="date-value">{{endDate |
          date:'dd-MMM-yyyy'}}</span>
      </div>
      <div>
        <button #cancelButton class="btn white-btn mr-2" type="button" (click)="closeDialog()">Cancel</button>
        <button class="btn blue-btn" type="submit" (click)="applyDateRange()">Apply</button>
      </div>
    </div>
  </mat-dialog-content>
</ng-template>
